import { useContext } from "react";
import { SharePropertyContext } from "./SharePropertyProvider.context";

const useShareProperty = () => {
  const context = useContext(SharePropertyContext);
  if (!context) {
    throw new Error("useShareProperty must be used within a SharePropertyProvider");
  }
  return context;
};

export default useShareProperty;
